import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './UsuariosData.css';
import baseURL from '../../url';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Register from '../Register/Register';

const modulesList = [
    { key: 'inicio', label: 'Inicio' },
    { key: 'reportes', label: 'Reportes' },
    { key: 'reservas', label: 'Reservas' },
    { key: 'pacientes', label: 'Pacientes' },
    { key: 'profesionales', label: 'Profesionales' },
    { key: 'productos', label: 'Productos' },
    { key: 'pedidos', label: 'Pedidos' },
    { key: 'inventarios', label: 'Inventarios' },
    { key: 'gastos', label: 'Gastos' },
    { key: 'evaluaciones', label: 'Evaluaciones' },
    { key: 'medios-pago', label: 'Medios de Pago' },
    { key: 'categorias', label: 'Categorías' },
    { key: 'banners', label: 'Banners' },
    { key: 'contacto', label: 'Contacto' },
    { key: 'usuarios', label: 'Usuarios' },
    { key: 'codigos', label: 'Códigos' },
    { key: 'testimonios', label: 'Testimonios' },
    { key: 'sucursales', label: 'Sucursales' },
    { key: 'horarios', label: 'Horarios' },
    { key: 'pwa', label: 'PWA' },
    { key: 'configuracion', label: 'Configuración' }
];

export default function UsuariosData() {
    const [usuarios, setUsuarios] = useState([]);
    const [filtroIdUsuario, setFiltroIdUsuario] = useState('');
    const [filtroNombre, setFiltroNombre] = useState('');

    // eslint-disable-next-line no-unused-vars
    const [filtroFechaDesde, setFiltroFechaDesde] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [filtroFechaHasta, setFiltroFechaHasta] = useState('');
    const [filtroEmail, setFiltroEmail] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);

    // Edit Modal State
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [editNombre, setEditNombre] = useState('');
    const [editEmail, setEditEmail] = useState('');
    const [editRol, setEditRol] = useState('');
    const [editContrasena, setEditContrasena] = useState('');
    const [showEditPassword, setShowEditPassword] = useState(false);
    const [editPermisos, setEditPermisos] = useState(
        modulesList.reduce((acc, m) => {
            acc[m.key] = { ver: false, editar: false };
            return acc;
        }, {})
    );
    const [mensajeEdit, setMensajeEdit] = useState('');
    const [errorEdit, setErrorEdit] = useState('');

    useEffect(() => {
        cargarUsuarios();
    }, []);

    const cargarUsuarios = () => {
        fetch(`${baseURL}/usuariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setUsuarios(data.usuarios || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const eliminarUsuario = (idUsuario) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/usuariosGet.php?idUsuario=${idUsuario}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarUsuarios();
                    })
                    .catch(error => {
                        console.error('Error al eliminar usuario:', error)
                        toast.success(error);
                    });
            }
        });
    };

    const abrirModalEditar = (usuario) => {
        setSelectedUser(usuario);
        setEditNombre(usuario.nombre || '');
        setEditEmail(usuario.email || '');
        setEditRol(usuario.rol || '');
        setEditContrasena(''); // empty password initially
        setShowEditPassword(false);
        setErrorEdit('');
        setMensajeEdit('');

        // Parse permissions if role is empleado
        let parsedPermisos = {};
        try {
            if (usuario.permisos) {
                parsedPermisos = typeof usuario.permisos === 'string' ? JSON.parse(usuario.permisos) : usuario.permisos;
            }
        } catch (e) {
            console.error("Error parsing user permissions", e);
        }

        const newPermisos = modulesList.reduce((acc, m) => {
            const userPerm = parsedPermisos[m.key] || { ver: false, editar: false };
            acc[m.key] = {
                ver: !!userPerm.ver,
                editar: !!userPerm.editar
            };
            return acc;
        }, {});

        setEditPermisos(newPermisos);
        setIsEditModalOpen(true);
    };

    const guardarEdicionUsuario = async (e) => {
        e.preventDefault();
        setMensajeEdit('Procesando...');
        setErrorEdit('');
        try {
            const payload = {
                nombre: editNombre,
                email: editEmail,
                rol: editRol,
                permisos: editRol === 'empleado' ? editPermisos : null
            };
            if (editContrasena) {
                payload.contrasena = editContrasena;
            }

            const response = await fetch(`${baseURL}/usuariosGet.php?idUsuario=${selectedUser.idUsuario}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.mensaje) {
                    toast.success(data.mensaje);
                    setIsEditModalOpen(false);
                    cargarUsuarios();
                } else if (data.error) {
                    setErrorEdit(data.error);
                    toast.error(data.error);
                }
            } else {
                throw new Error('Error en la solicitud al servidor');
            }
        } catch (error) {
            console.error('Error:', error.message);
            toast.error(error.message);
        } finally {
            setMensajeEdit('');
        }
    };

    const usuariosFiltrados = usuarios.filter(usuario => {
        const idUsuarioMatch = usuario.idUsuario.toString().includes(filtroIdUsuario);
        const nombreMatch = usuario.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
        const fechaDesdeMatch = !filtroFechaDesde || new Date(usuario.createdAt) >= new Date(filtroFechaDesde);
        const fechaHastaMatch = !filtroFechaHasta || new Date(usuario.createdAt) <= new Date(filtroFechaHasta);
        const emailMatch = usuario.email.toLowerCase().includes(filtroEmail.toLowerCase());

        return idUsuarioMatch && nombreMatch && fechaDesdeMatch && fechaHastaMatch && emailMatch;
    });

    const descargarExcel = () => {
        const data = usuariosFiltrados.map(usuarios => ({

            'ID Usuario': usuarios.idUsuario,
            Nombre: usuarios.nombre,
            Email: usuarios.email,
            Fecha: usuarios.createdAt,

        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Usuarios');
        XLSX.writeFile(wb, 'usuarios.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF();
        pdf.text('Lista de Usuarios', 10, 10);

        const columns = [

            { title: 'ID Usuario', dataKey: 'idUsuario' },
            { title: 'Nombre', dataKey: 'nombre' },
            { title: 'Email', dataKey: 'email' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        const data = usuariosFiltrados.map(usuarios => ({

            idUsuario: usuarios.idUsuario,
            nombre: usuarios.nombre,
            email: usuarios.email,
            createdAt: usuarios.createdAt,
        }));

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('usuarios.pdf');
    };
    const recargarUsuarios = () => {
        cargarUsuarios();
    };
    const invertirOrden = () => {
        setUsuarios([...usuarios].reverse());
        setOrdenInvertido(!ordenInvertido);
    };
    return (
        <div>
            <div className='deFlexContent'>
                <div className='deFlex2'>
                    <Register />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>

                </div>


                <div className='gastosFiltros'>
                    <input type="number" value={filtroIdUsuario} onChange={(e) => setFiltroIdUsuario(e.target.value)} placeholder='ID Usuario' className='filtroInput' />
                    <input type="text" value={filtroNombre} onChange={(e) => setFiltroNombre(e.target.value)} placeholder='Nombre' className='filtroInput' />
                    <input type="text" value={filtroEmail} onChange={(e) => setFiltroEmail(e.target.value)} placeholder='Email' className='filtroInput' />


                    <button className='reload' onClick={recargarUsuarios}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>


                </div>
            </div>


            <div className='table-container'>
                <ToastContainer />

                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID Usuario</th>
                            <th>Nombre</th>
                            <th>Email</th>

                            <th>Fecha Creación</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuariosFiltrados.map(usuario => (
                            <tr key={usuario.idUsuario}>
                                <td>{usuario.idUsuario}</td>
                                <td>{usuario.nombre}</td>
                                <td>{usuario.email}</td>

                                <td>{usuario.createdAt}</td>
                                <td>
                                    <button className='editar' style={{ marginRight: '10px' }} onClick={() => abrirModalEditar(usuario)}><FontAwesomeIcon icon={faEdit} /></button>
                                    <button className='eliminar' onClick={() => eliminarUsuario(usuario.idUsuario)}><FontAwesomeIcon icon={faTrash} /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>

            {isEditModalOpen && selectedUser && (
                <div className="modal">
                    <div className="modal-content" style={{ maxWidth: editRol === 'empleado' ? '800px' : '500px', transition: 'max-width 0.3s ease' }}>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Editar Usuario</button>
                            <span className="close" onClick={() => setIsEditModalOpen(false)}>&times;</span>
                        </div>
                        <form onSubmit={guardarEdicionUsuario} id='editarForm'>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        type="text"
                                        value={editNombre}
                                        onChange={(e) => setEditNombre(e.target.value)}
                                        required
                                        placeholder="Nombre"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Email</legend>
                                    <input
                                        type="email"
                                        value={editEmail}
                                        onChange={(e) => setEditEmail(e.target.value)}
                                        required
                                        placeholder="Email"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Rol</legend>
                                    <select
                                        value={editRol}
                                        onChange={(e) => setEditRol(e.target.value)}
                                        required
                                    >
                                        <option value="">Seleccione un rol</option>
                                        <option value="admin">Administrador</option>
                                        <option value="empleado">Empleado</option>
                                        <option value="usuario">Usuario</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Contraseña (Opcional)</legend>
                                    <div className='deFlexPass'>
                                        <input
                                            type={showEditPassword ? 'text' : 'password'}
                                            value={editContrasena}
                                            onChange={(e) => setEditContrasena(e.target.value)}
                                            placeholder="Nueva contraseña (dejar en blanco para conservar)"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowEditPassword(!showEditPassword)}
                                        >
                                            <FontAwesomeIcon icon={showEditPassword ? faEyeSlash : faEye} />
                                        </button>
                                    </div>
                                </fieldset>
                            </div>

                            {editRol === 'empleado' && (
                                <div className="permisos-container">
                                    <h3 style={{ margin: '15px 0 10px', fontSize: '1.1rem', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Configurar Permisos de Empleado</h3>
                                    <div className="permisos-scroll" style={{ maxHeight: '250px', overflowY: 'auto', paddingRight: '5px' }}>
                                        <table className="permisos-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                                    <th style={{ padding: '8px' }}>Módulo</th>
                                                    <th style={{ padding: '8px', textAlign: 'center' }}>Ver</th>
                                                    <th style={{ padding: '8px', textAlign: 'center' }}>Editar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {modulesList.map((m) => (
                                                    <tr key={m.key} style={{ borderBottom: '1px solid #eee' }}>
                                                        <td style={{ padding: '8px', fontWeight: '500' }}>{m.label}</td>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                                checked={editPermisos[m.key]?.ver || false}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setEditPermisos(prev => ({
                                                                        ...prev,
                                                                        [m.key]: {
                                                                            ...prev[m.key],
                                                                            ver: checked,
                                                                            editar: checked ? prev[m.key].editar : false
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </td>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                                                checked={editPermisos[m.key]?.editar || false}
                                                                disabled={!editPermisos[m.key]?.ver}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setEditPermisos(prev => ({
                                                                        ...prev,
                                                                        [m.key]: {
                                                                            ...prev[m.key],
                                                                            editar: checked
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {errorEdit && <div style={{ color: 'red', marginTop: '10px' }}>{errorEdit}</div>}

                            {mensajeEdit ? (
                                <button type="button" className='btnLoading' disabled style={{ marginTop: '15px' }}>
                                    {mensajeEdit}
                                </button>
                            ) : (
                                <button type="submit" className='btnPost' style={{ marginTop: '15px' }}>
                                    Guardar Cambios
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
